module.exports = __webpack_public_path__ + "img/earth.3fe6d801.jpg";